module.exports = __webpack_public_path__ + "img/block-engineering.117d8dfa.png";